<template>

        <div style="width:100%">
            <div class="form-field-group">
                <div class="form-field" v-if="!parentImage && !img.ImagePath && !img.Image.FileData">
                    <input :name="name + 'UseMainPhoto'" :id="name + 'UseMainPhoto'" value="true" type="checkbox" class="input-checkbox"
                           v-model="img.ImageStyle.useMainPhoto" @change="onChangeUseMainPhoto($event)" />
                    <label :for="name + 'UseMainPhoto'" class="input-checkbox-lbl">Использовать одну фотографию</label>
                </div>
                <div class="form-field file-uploaded" v-if="img.ImagePath && !img.ImageStyle.useMainPhoto">
                    <img :src="img.ImagePath" />
                </div>
                <div class="form-field">
                    <div class="flex">
                        <div class="file-upload-zone" v-if="!img.ImageStyle.useMainPhoto">
                            <input type="file" :id="name + 'dropFiles'" :name="name + 'dropFiles'"
                                   class="file-upload-zone-btn" accept=".jpg,.jpeg,.png,.gif,.bmp" />
                            <label id="dropFilesBtnLbl" :for="name + 'dropFiles'" class="file-upload-zone-lbl">
                                Загрузить
                            </label>
                        </div>
                        <div class="margin-left-10" style="display:inline-block">
                            <button type="button" class="btn btn-delete" @click="removeImage()"
                                    v-if="img.ImagePath || img.Image.FileData">
                                Удалить
                            </button>
                        </div>
                    </div>
                    <div v-if="filename && !img.ImageStyle.useMainPhoto" class="fileList margin-top-5">
                        Выбран файл: {{filename}}
                    </div>
                    <div class="form-field margin-top-10">
                        <label class="input-text-lbl">
                            Размер изображения, %
                        </label>
                        <touch-spin v-model="img.ImageStyle.size" :min="0" :defaultValue="0"></touch-spin>
                    </div>
                    <div>
                        <input :name="name + 'Size'" :id="name + 'St1'" value="1" type="radio" class="input-checkbox" selected
                               @change="" v-model.number="img.ImageStyle.resizeType" />
                        <label :for="name + 'St1'" class="input-checkbox-lbl no-margin-top">Высота или</label>
                        <input :name="name + 'Size'" :id="name + 'St2'" value="2" type="radio" class="input-checkbox"
                               @change="" v-model.number="img.ImageStyle.resizeType" />
                        <label :for="name + 'St2'" class="input-checkbox-lbl no-margin-top">Ширина</label>
                    </div>
                </div>
            </div>
            <div class="line-separator margin-bottom-15 margin-top-15"></div>
            <p class="input-text-lbl"><b>Вертикаль</b></p>
            <div class="form-field-group">
                <div class="form-field">
                    <label class="input-text-lbl">
                        Расположение, %
                    </label>
                    <touch-spin v-model="img.ImageStyle.top" :min="-100" :max="100" :defaultValue="0"></touch-spin>
                </div>
                <div class="form-field">
                    <label class="input-text-lbl">
                        Выравнивание, %
                    </label>
                    <touch-spin v-model="img.ImageStyle.translateY" :min="-100" :max="100" :defaultValue="0"></touch-spin>
                </div>
                <div class="form-field" style="width:35px;min-width:35px;padding-top:23px">
                    <button type="button" class="btn btn-default btn-img"
                            @click="setImageStyleParams({top: 0, translateY: 0})">
                        <img src="../../img/align-top.png" alt="" />
                    </button>
                </div>
                <div class="form-field" style="width:35px;min-width:35px;padding-top:23px">
                    <button type="button" class="btn btn-default btn-img"
                            @click="setImageStyleParams({top: 50, translateY: -50})">
                        <img src="../../img/align-middle.png" alt="" />
                    </button>
                </div>
                <div class="form-field" style="width:35px;min-width:35px;padding-top:23px">
                    <button type="button" class="btn btn-default btn-img"
                            @click="setImageStyleParams({top: 100, translateY: -100})">
                        <img src="../../img/align-bottom.png" alt="" />
                    </button>
                </div>
            </div>
            <div class="line-separator margin-bottom-15 margin-top-15"></div>
            <p class="input-text-lbl"><b>Горизонталь</b></p>
            <div class="form-field-group">
                <div class="form-field">
                    <label class="input-text-lbl">
                        Расположение, %
                    </label>
                    <touch-spin v-model="img.ImageStyle.left" :min="-100" :max="100" :defaultValue="0"></touch-spin>
                </div>
                <div class="form-field">
                    <label class="input-text-lbl">
                        Выравнивание, %
                    </label>
                    <touch-spin v-model="img.ImageStyle.translateX" :min="-100" :max="100" :defaultValue="0"></touch-spin>
                </div>
                <div class="form-field" style="width:35px;min-width:35px;padding-top:23px">
                    <button type="button" class="btn btn-default btn-img"
                            @click="setImageStyleParams({left: 0, translateX: 0})">
                        <img src="../../img/align-left.png" alt="" />
                    </button>
                </div>
                <div class="form-field" style="width:35px;min-width:35px;padding-top:23px">
                    <button type="button" class="btn btn-default btn-img"
                            @click="setImageStyleParams({left: 50, translateX: -50})">
                        <img src="../../img/align-center.png" alt="" />
                    </button>
                </div>
                <div class="form-field" style="width:35px;min-width:35px;padding-top:23px">
                    <button type="button" class="btn btn-default btn-img"
                            @click="setImageStyleParams({left: 100, translateX: -100})">
                        <img src="../../img/align-right.png" alt="" />
                    </button>
                </div>
            </div>
        </div>

</template>

<script>
    import $ from 'jquery'
    import UI from '../helpers/ui-helpers'

    export default {
        name: "image-setting",

        props: ['img', 'parentImgPath', 'name', 'parentImage'],

        data(){
            return {
                filename: ''
            }
        },

        watch: {
            parentImgPath: function (newVal, oldVal) {
                //console.info('watch parent image', newVal, oldVal);
                this.img.ParentImgPath = newVal;
                this.onChangeUseMainPhoto(null);
            }
        },

        computed:{
        },

        methods: {
            setImageStyleParams(style) {
                let vm = this;
                for(let p in style){
                    vm.img.ImageStyle[p] = style[p];
                }
                //console.info('setImageStyleParams', this.name, style);
                vm.$emit('onImageStyleParamsChanged', vm.img.ImageStyle, vm.name,);
            },

            removeImage() {
                let vm = this;
                vm.img.Image.FileName = null;
                vm.img.Image.FileData = null;
                vm.img.ImagePath = null;
                vm.img.Image.Id = -1;
                vm.img.ImageView = null;
                vm.filename = '';

                this.onChangeUseMainPhoto(null);
            },

            onChangeUseMainPhoto(e) {
                let vm = this;
                vm.$nextTick(() => {
                    if (vm.img.ImageStyle.useMainPhoto) {
                        if (vm.img.ParentImgPath)
                            vm.img.ImageView = vm.img.ParentImgPath;
                        else
                            vm.img.ImageView = null;
                    } else if (vm.img.Image.FileData) {
                        vm.img.ImageView = vm.img.Image.FileData;
                    } else {
                        vm.img.ImageView = vm.img.ImagePath;
                    }
                    vm.$emit('onImageViewChanged', vm.img.ImageView, vm.name,);
                });
            },
        },

        mounted() {
            let vm = this;

            $(document).on('change', '[name="' + vm.name + 'dropFiles"]', function () {
                if (this.files && this.files[0]) {
                    if (this.files[0].size > 50 * 1024 * 1024) {
                        UI.toastr.error('Превышен размер. Выберите другой файл');
                        $('[name="' + vm.name + 'dropFiles"]').val('');
                    } else {
                        vm.file = this.files[0];
                        vm.img.Image.FileName = vm.file.name;
                        vm.filename = '';
                        vm.img.Image.FileData = null;
                        vm.img.Image.Id = -1;

                        let reader = new FileReader();
                        reader.onload = function (e) {
                            vm.filename = vm.file.name;
                            vm.img.Image.FileData = e.target.result;
                            vm.$emit('onImageViewChanged', vm.img.Image.FileData, vm.name,);
                        };
                        reader.readAsDataURL(this.files[0]);
                    }
                }
            });

            vm.$nextTick(() => {
                //console.info('mountead', vm.img);
                vm.img.Image = {};
                vm.img.ImageView = vm.img.ImagePath;
                if (vm.img.ImageStyle.useMainPhoto) {
                    vm.img.ImagePath = null;
                } 
                vm.$emit('onImageViewChanged', vm.img.ImageView, vm.name,);
            });
        },

        destroyed(){
            $(document).off('change', '[name="' + this.name + 'dropFiles"]');
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// Content/src/components/ImageSetting.vue